function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgWalk = function SvgWalk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.99 511.99",
    style: {
      enableBackground: "new 0 0 511.99 511.99"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    style: {
      fill: "#FFB69E"
    },
    d: "M453.305,282.437l-68.906-57.176c-0.925-0.767-1.779-1.615-2.554-2.533l-67.393-79.953 c-7.21-8.555-6.122-21.335,2.434-28.546c8.554-7.211,21.334-6.122,28.546,2.433l66.229,78.572l67.516,56.023 c8.61,7.145,9.798,19.916,2.654,28.526C474.665,288.418,461.892,289.561,453.305,282.437z"
  }), React.createElement("path", {
    style: {
      fill: "#5F6E9B"
    },
    d: "M401.225,138.146c1.362-16.419-10.817-30.844-27.232-32.255l-53.204-4.574 c-16.45-1.414-30.932,10.775-32.346,27.225l-12.671,147.392c-0.31,3.604-0.192,7.231,0.35,10.807l13.802,91.034l-38.342,101.66 c-4.689,12.433,1.588,26.313,14.021,31.002c12.378,4.668,26.293-1.533,31.002-14.021l40.585-107.605 c1.47-3.897,1.903-8.109,1.257-12.223l-12.768-97.186l63.35,5.819L401.225,138.146z"
  }), React.createElement("path", {
    style: {
      fill: "#414B82"
    },
    d: "M403.824,493.258L377.08,375.627l-42.03-93.004c-5.472-12.109-0.092-26.361,12.017-31.833 c12.108-5.472,26.36-0.092,31.833,12.017l43.028,95.214c0.664,1.469,1.179,3.002,1.536,4.574l27.282,119.995 c2.946,12.957-5.17,25.849-18.127,28.795C419.631,514.339,406.763,506.183,403.824,493.258z"
  }), React.createElement("path", {
    style: {
      fill: "#64AFFF"
    },
    d: "M389.028,285.219l-113.161-10.394l12.576-146.285c1.414-16.45,15.896-28.638,32.345-27.224 l53.205,4.574c16.415,1.411,28.593,15.837,27.232,32.255L389.028,285.219z"
  }), React.createElement("circle", {
    style: {
      fill: "#FFB69E"
    },
    cx: 360.145,
    cy: 44.25,
    r: 44.25
  }), React.createElement("path", {
    style: {
      fill: "#E89F87"
    },
    d: "M224.509,307.363c-10.356-4.233-15.32-16.061-11.086-26.417l33.88-82.881 c0.797-1.947,1.891-3.758,3.244-5.369l63.886-76.012c7.199-8.566,19.978-9.672,28.542-2.474c8.564,7.199,9.672,19.977,2.473,28.542 l-61.844,73.582l-32.68,79.943C246.673,306.684,234.816,311.576,224.509,307.363z"
  }), React.createElement("path", {
    style: {
      fill: "#78BEFF"
    },
    d: "M316.175,177.583l29.275-34.832c7.199-8.564,6.091-21.343-2.473-28.542 c-8.564-7.198-21.343-6.092-28.542,2.475l-30.788,36.632L316.175,177.583z"
  }), React.createElement("path", {
    style: {
      fill: "#414B82"
    },
    d: "M116.045,493.288l8.153-70.329l-10.567-61.616c-1.565-9.128,4.566-17.797,13.693-19.362 c9.129-1.564,17.796,4.565,19.362,13.693l10.974,63.99c0.27,1.574,0.313,3.179,0.13,4.766l-8.431,72.721 c-1.067,9.199-9.389,15.792-18.589,14.726C121.557,510.804,114.98,502.478,116.045,493.288z"
  }), React.createElement("path", {
    style: {
      fill: "#5F6E9B"
    },
    d: "M30.552,490.283c-6.728-6.367-6.674-17.398-0.28-24.101l44.165-48.928l3.011-49.228 c2.666-8.865,12.011-13.892,20.876-11.232c0.004,0.001-0.003-0.001,0,0c8.869,2.667,13.907,12.023,11.24,20.891l-7.303,54.182 c-0.511,3.661-2.159,7.07-4.71,9.745l-43.34,48.063C47.805,496.39,37.226,496.598,30.552,490.283z"
  }), React.createElement("path", {
    style: {
      fill: "#1E2D64"
    },
    d: "M150.632,377.615H76.928v-3.505l8.134-101.82c0.971-12.16,11.611-21.232,23.772-20.27l28.238,2.234 c12.068,0.955,21.122,11.441,20.306,23.52L150.632,377.615z"
  }), React.createElement("path", {
    style: {
      fill: "#1E73BE"
    },
    d: "M80.612,327.804l-13.143-0.871l0.831-12.539l13.143,0.871c25.294,1.681,47.21-17.527,48.886-42.807 c0.193-2.919-0.761-5.739-2.689-7.94c-1.928-2.201-4.596-3.52-7.515-3.713l-48.06-3.186l0.831-12.539l48.06,3.186 c6.268,0.415,12,3.247,16.139,7.973c4.138,4.726,6.189,10.781,5.773,17.05C140.732,305.484,112.798,329.939,80.612,327.804z"
  }), React.createElement("path", {
    style: {
      fill: "#2896FF"
    },
    d: "M89.71,329.337c-0.797,12.025-11.192,21.127-23.216,20.33c-12.025-0.797-21.127-11.192-20.33-23.216 l4.757-71.759c0.797-12.025,11.192-21.127,23.216-20.33s21.127,11.192,20.33,23.216L89.71,329.337z"
  }), React.createElement("path", {
    style: {
      fill: "#1E73BE"
    },
    d: "M46.164,326.45l2.379-35.88l-6.323-0.419c-3.847-0.255-7.172,2.657-7.427,6.504l-1.478,22.289 c-0.255,3.847,2.657,7.172,6.504,7.427l6.331,0.42C46.156,326.678,46.157,326.565,46.164,326.45z"
  }), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#FFB69E"
    },
    cx: 123.525,
    cy: 195.72,
    r: 36.24
  }), React.createElement("path", {
    style: {
      fill: "#FFB69E"
    },
    d: "M164.722,309.858l-51.943-22.13c-7.206-3.07-10.559-11.4-7.489-18.606s11.401-10.559,18.607-7.489 l48.182,20.527l52.993-8.476c7.735-1.24,15.007,4.03,16.244,11.764s-4.03,15.007-11.765,16.244l-57.03,9.122 C169.941,311.227,167.233,310.927,164.722,309.858z"
  })), React.createElement("path", {
    style: {
      fill: "#263980"
    },
    d: "M164.722,309.858l-51.943-22.13c-7.206-3.07-10.559-11.4-7.489-18.606s11.401-10.559,18.607-7.489 l48.182,20.527l52.993-8.476l4.48,28.009l-57.03,9.122C169.941,311.227,167.233,310.927,164.722,309.858z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWalk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/walk.a2816e32.svg";
export { ForwardRef as ReactComponent };